import {
  //
  ADD_EMPLOYEE,
  ADD_EMPLOYEE_FAILURE,
  ADD_EMPLOYEE_SUCCESS,
  //
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_FAILURE,
  DELETE_EMPLOYEE_SUCCESS,
  //
  EDIT_EMPLOYEE,
  EDIT_EMPLOYEE_FAILURE,
  EDIT_EMPLOYEE_SUCCESS,
  //
  FETCH_EMPLOYEE,
  FETCH_EMPLOYEE_FAILURE,
  FETCH_EMPLOYEE_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  DEFAULT_PERMS,
  SET_CURRENT_PERMS,
  //
  SEARCH_EMPLOYEE,
  SEARCH_EMPLOYEE_SUCCESS,
  SEARCH_EMPLOYEE_FAILURE,
  //
  SAVE_INFO,
  SAVE_INFO_SUCCESS,
  SAVE_INFO_FAILURE,
  //
  SAVE_DOCS,
  SAVE_DOCS_SUCCESS,
  SAVE_DOCS_FAILURE,
  //
  SAVE_SCHEDULE,
  SAVE_SCHEDULE_SUCCESS,
  SAVE_SCHEDULE_FAILURE,
  //
  SEND_INVITE,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_FAILURE,
  //
  TOGGLE_PIN_MODAL,
  TOGGLE_MAIL_MODAL,
  //
  SAVE_PROFILE,
  SAVE_PROFILE_SUCCESS,
  SAVE_PROFILE_FAILURE,
  TOGGLE_DOC_MODAL,
  //
  SAVE_PAYROLL,
  SAVE_PAYROLL_SUCCESS,
  SAVE_PAYROLL_FAILURE,
  //
  DELETE_DOC,
  DELETE_DOC_SUCCESS,
  DELETE_DOC_FAILURE,
  //
  SAVE_PIN,
  SAVE_PIN_SUCCESS,
  SAVE_PIN_FAILURE,
  //
  SEND_MAIL,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_FAILURE,
  //
  UPLOAD_CSV,
  UPLOAD_CSV_SUCCESS,
  UPLOAD_CSV_FAILURE,
  //
  SEARCH_MANAGER,
  SEARCH_MANAGER_SUCCESS,
  SEARCH_MANAGER_FAILURE,
  TOGGLE_IMAGE_MODAL,
  //
  IMPORT_CSV,
  IMPORT_CSV_SUCCESS,
  IMPORT_CSV_FAILURE,
  TOGGLE_LEAVE_CALC,
  //
  GET_EMP_HISTORY,
  GET_EMP_HISTORY_SUCCESS,
  GET_EMP_HISTORY_FAILURE,
  //
  TOGGLE_HISTORY_MODAL,
  //
  GET_BIRTHDAYS,
  GET_BIRTHDAYS_SUCCESS,
  GET_BIRTHDAYS_FAILURE,
  //
  GET_EXPIRING_DOCS,
  GET_EXPIRING_DOCS_SUCCESS,
  GET_EXPIRING_DOCS_FAILURE,
  //
  GET_EMPTY_SHIFTS,
  GET_EMPTY_SHIFTS_SUCCESS,
  GET_EMPTY_SHIFTS_FAILURE,
  //
  GET_EMPTY_CLOCKS,
  GET_EMPTY_CLOCKS_SUCCESS,
  GET_EMPTY_CLOCKS_FAILURE,
  //
  SEARCH_ROTA_EMPLOYEE,
  SEARCH_ROTA_EMPLOYEE_SUCCESS,
  SEARCH_ROTA_EMPLOYEE_FAILURE,
} from "./constants";

// List
export const fetchEmployee = (payload, onSuccess) => ({
  type: FETCH_EMPLOYEE,
  payload,
  onSuccess,
});
export const fetchEmployeeSuccess = (payload) => ({
  type: FETCH_EMPLOYEE_SUCCESS,
  payload,
});
export const fetchEmployeeFailure = (payload) => ({
  type: FETCH_EMPLOYEE_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addEmployee = (payload, history) => ({
  type: ADD_EMPLOYEE,
  payload,
  history,
});
export const addEmployeeSuccess = (payload) => ({
  type: ADD_EMPLOYEE_SUCCESS,
  payload,
});
export const addEmployeeFailure = (payload) => ({
  type: ADD_EMPLOYEE_FAILURE,
  payload,
});
// EDIT
export const editEmployee = (payload) => ({
  type: EDIT_EMPLOYEE,
  payload,
});
export const editEmployeeSuccess = (payload) => ({
  type: EDIT_EMPLOYEE_SUCCESS,
  payload,
});
export const editEmployeeFailure = (payload) => ({
  type: EDIT_EMPLOYEE_FAILURE,
  payload,
});
// DELETE
export const deleteEmployee = (payload) => ({
  type: DELETE_EMPLOYEE,
  payload,
});
export const deleteEmployeeSuccess = (payload) => ({
  type: DELETE_EMPLOYEE_SUCCESS,
  payload,
});
export const deleteEmployeeFailure = (payload) => ({
  type: DELETE_EMPLOYEE_FAILURE,
  payload,
});
//
export const setDefaultPerms = (payload) => ({
  type: DEFAULT_PERMS,
  payload,
});
export const setCurrentPerms = (payload) => ({
  type: SET_CURRENT_PERMS,
  payload,
});
export const searchEmployee = (payload, onSuccess, values) => ({
  type: SEARCH_EMPLOYEE,
  payload,
  onSuccess,
  values,
});
export const searchEmployeeSuccess = (payload) => ({
  type: SEARCH_EMPLOYEE_SUCCESS,
  payload,
});
export const searchEmployeeFailure = (payload) => ({
  type: SEARCH_EMPLOYEE_FAILURE,
  payload,
});
export const saveInfo = (payload) => ({ type: SAVE_INFO, payload });
export const saveInfoSuccess = (payload) => ({
  type: SAVE_INFO_SUCCESS,
  payload,
});
export const saveInfoFailure = (payload) => ({
  type: SAVE_INFO_FAILURE,
  payload,
});
export const saveDocs = (payload, onSaveDocs) => ({
  type: SAVE_DOCS,
  payload,
  onSaveDocs,
});
export const saveDocsSuccess = (payload) => ({
  type: SAVE_DOCS_SUCCESS,
  payload,
});
export const saveDocsFailure = (payload) => ({
  type: SAVE_DOCS_FAILURE,
  payload,
});
//
export const saveSchedule = (payload) => ({ type: SAVE_SCHEDULE, payload });
export const saveScheduleSuccess = (payload) => ({
  type: SAVE_SCHEDULE_SUCCESS,
  payload,
});
export const saveScheduleFailure = (payload) => ({
  type: SAVE_SCHEDULE_FAILURE,
  payload,
});

//
export const sendInvite = (payload, onSend) => ({
  type: SEND_INVITE,
  payload,
  onSend,
});
export const sendInviteSuccess = (payload) => ({
  type: SEND_INVITE_SUCCESS,
  payload,
});
export const sendInviteFailure = (payload) => ({
  type: SEND_INVITE_FAILURE,
  payload,
});
//
export const togglePinModal = (payload) => ({
  type: TOGGLE_PIN_MODAL,
  payload,
});

//
export const saveProfile = (payload, onSave) => ({
  type: SAVE_PROFILE,
  payload,
  onSave,
});
export const saveProfileSuccess = (payload) => ({
  type: SAVE_PROFILE_SUCCESS,
  payload,
});
export const saveProfileFailure = (payload) => ({
  type: SAVE_PROFILE_FAILURE,
  payload,
});
export const toggleDocModal = (payload) => ({
  type: TOGGLE_DOC_MODAL,
  payload,
});
//
export const savePayroll = (payload) => ({
  type: SAVE_PAYROLL,
  payload,
});
export const savePayrollSuccess = (payload) => ({
  type: SAVE_PAYROLL_SUCCESS,
  payload,
});
export const savePayrollFailure = (payload) => ({
  type: SAVE_PAYROLL_FAILURE,
  payload,
});
//
export const deleteDoc = (payload) => ({
  type: DELETE_DOC,
  payload,
});
export const deleteDocSuccess = (payload) => ({
  type: DELETE_DOC_SUCCESS,
  payload,
});
export const deleteDocFailure = (payload) => ({
  type: DELETE_DOC_FAILURE,
  payload,
});
//
export const savePin = (payload, onSuccess) => ({
  type: SAVE_PIN,
  payload,
  onSuccess,
});
export const savePinSuccess = (payload) => ({
  type: SAVE_PIN_SUCCESS,
  payload,
});
export const savePinFailure = (payload) => ({
  type: SAVE_PIN_FAILURE,
  payload,
});
export const toggleMailModal = (payload) => ({
  type: TOGGLE_MAIL_MODAL,
  payload,
});
//
export const sendMail = (payload, onMail) => ({
  type: SEND_MAIL,
  payload,
  onMail,
});
export const sendMailSuccess = (payload) => ({
  type: SEND_MAIL_SUCCESS,
  payload,
});
export const sendMailFailure = (payload) => ({
  type: SEND_MAIL_FAILURE,
  payload,
});
//
export const uploadCSV = (payload) => ({
  type: UPLOAD_CSV,
  payload,
});
export const uploadCSVSuccess = (payload) => ({
  type: UPLOAD_CSV_SUCCESS,
  payload,
});
export const uploadCSVFailure = (payload) => ({
  type: UPLOAD_CSV_FAILURE,
  payload,
});

export const searchManager = (payload, onSuccess, values) => ({
  type: SEARCH_MANAGER,
  payload,
  onSuccess,
  values,
});
export const searchManagerSuccess = (payload) => ({
  type: SEARCH_MANAGER_SUCCESS,
  payload,
});
export const searchManagerFailure = (payload) => ({
  type: SEARCH_MANAGER_FAILURE,
  payload,
});

export const toggleImageModal = (payload) => ({
  type: TOGGLE_IMAGE_MODAL,
  payload,
});

export const importCSV = (payload, onImport) => ({
  type: IMPORT_CSV,
  payload,
  onImport,
});
export const importCSVSuccess = (payload) => ({
  type: IMPORT_CSV_SUCCESS,
  payload,
});
export const importCSVFailure = (payload) => ({
  type: IMPORT_CSV_FAILURE,
  payload,
});

export const toggleLeaveCalc = (payload) => ({
  type: TOGGLE_LEAVE_CALC,
  payload,
});

export const getEmpHistory = (payload) => ({
  type: GET_EMP_HISTORY,
  payload,
});
export const getEmpHistorySuccess = (payload) => ({
  type: GET_EMP_HISTORY_SUCCESS,
  payload,
});
export const getEmpHistoryFailure = (payload) => ({
  type: GET_EMP_HISTORY_FAILURE,
  payload,
});

export const toggleHistoryModal = (payload) => ({
  type: TOGGLE_HISTORY_MODAL,
  payload,
});

export const getBirthdays = (payload) => ({
  type: GET_BIRTHDAYS,
  payload,
});
export const getBirthdaysSuccess = (payload) => ({
  type: GET_BIRTHDAYS_SUCCESS,
  payload,
});
export const getBirthdaysFailure = (payload) => ({
  type: GET_BIRTHDAYS_FAILURE,
  payload,
});

export const getExpiringDocs = (payload) => ({
  type: GET_EXPIRING_DOCS,
  payload,
});
export const getExpiringDocsSuccess = (payload) => ({
  type: GET_EXPIRING_DOCS_SUCCESS,
  payload,
});
export const getExpiringDocsFailure = (payload) => ({
  type: GET_EXPIRING_DOCS_FAILURE,
  payload,
});

export const getEmptyShifts = (payload) => ({
  type: GET_EMPTY_SHIFTS,
  payload,
});
export const getEmptyShiftsSuccess = (payload) => ({
  type: GET_EMPTY_SHIFTS_SUCCESS,
  payload,
});
export const getEmptyShiftsFailure = (payload) => ({
  type: GET_EMPTY_SHIFTS_FAILURE,
  payload,
});

export const getEmptyClocks = (payload) => ({
  type: GET_EMPTY_CLOCKS,
  payload,
});
export const getEmptyClocksSuccess = (payload) => ({
  type: GET_EMPTY_CLOCKS_SUCCESS,
  payload,
});
export const getEmptyClocksFailure = (payload) => ({
  type: GET_EMPTY_CLOCKS_FAILURE,
  payload,
});

export const searchRotaEmployee = (payload) => ({
  type: SEARCH_ROTA_EMPLOYEE,
  payload,
});
export const searchRotaEmployeeSuccess = (payload) => ({
  type: SEARCH_ROTA_EMPLOYEE_SUCCESS,
  payload,
});
export const searchRotaEmployeeFailure = (payload) => ({
  type: SEARCH_ROTA_EMPLOYEE_FAILURE,
  payload,
});
